import React, { useContext } from "react";
import { MessagingBridgeManager } from "../helpers/bridge/common";
import { MessagingBridgeManagerMaster } from "../helpers/bridge/master";
import { MessagingBridgeManagerSlave } from "../helpers/bridge/slave";

export const MessagingBridgeContext = React.createContext<MessagingBridgeManagerMaster | MessagingBridgeManagerSlave | undefined>(undefined);

export const useMessagingBridgeManagerContext = (enabled: boolean = true): MessagingBridgeManagerMaster | MessagingBridgeManagerSlave | undefined => {
  const bridge = useContext(MessagingBridgeContext);
  if (!enabled) return undefined;
  if (!bridge) return undefined;
  return bridge;
};

export const useMessagingBridgeManagerMasterContext = (enabled: boolean = true): MessagingBridgeManagerMaster | undefined => {
  const bridge = useMessagingBridgeManagerContext(enabled);
  if (!bridge) return undefined;
  if (!MessagingBridgeManager.isMasterManager(bridge)) return undefined;
  return bridge;
};

export const useMessagingBridgeManagerSlaveContext = (enabled: boolean = true): MessagingBridgeManagerSlave | undefined => {
  const bridge = useMessagingBridgeManagerContext(enabled);
  if (!bridge) return undefined;
  if (!MessagingBridgeManager.isSlaveManager(bridge)) return undefined;
  return bridge;
};
